import { render, staticRenderFns } from "./FormSignupRequest.vue?vue&type=template&id=3ccd0bb0"
import script from "./FormSignupRequest.vue?vue&type=script&lang=js"
export * from "./FormSignupRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports